//code
import React, { FC, useRef, useState } from 'react';
import { useHistory } from 'react-router';

//devextreem
import Button from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';

//components
import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { DropDownButton } from 'devextreme-react';
//store
import $createStore from 'utils/create-store-instance';

import { CloneRole } from './modals';
import ModalDelete from './modals/delete';

export const variants = [
  { id: 1, name: 'Редактировать', icon: 'edit' },
  { id: 2, name: 'Скопировать', icon: 'copy' },
  { id: 3, name: 'Удалить', icon: 'trash' },
];

const Role: FC = () => {
  const roleData: any = $createStore('/v1/role', 'id');
  const history = useHistory();
  const [visibleModalDelete, setVisibleModalDelete] = useState<boolean>(false);
  const [visibleModalClone, setVisibleModalClone] = useState<boolean>(false);
  const [openId, setOpenId] = useState<number | null>(null);
  let refGrid = useRef<DataGrid | null>(null);

  const handleRefresh = () => refGrid.current?.instance.refresh();

  const onItemClickHandler = async (val: any, id: number) => {
    if (val.itemData.id === 1) {
      history.push(`/role/${id}`);
    }

    if (val.itemData.id === 2) {
      setOpenId(id);
      setVisibleModalClone(true);
    }

    if (val.itemData.id === 3) {
      setOpenId(id);
      setVisibleModalDelete(true);
    }
  };

  return (
    <div className="container-dev">
      <ModalDelete
        visible={visibleModalDelete}
        changeVisible={setVisibleModalDelete}
        id={openId}
        refresh={handleRefresh}
      />

      <AppLayoutTop title="Роли">
        <ClaimsProvider claimsBlock={['CanEditRoles']}>
          <Button
            width={120}
            text="Добавить"
            type="default"
            onClick={() => {
              history.push('/role-add');
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>

      {openId && (
        <CloneRole
          changeVisible={setVisibleModalClone}
          onRefresh={handleRefresh}
          roleId={openId}
          visible={visibleModalClone}
        />
      )}

      <AppCard>
        <DataGrid
          dataSource={roleData}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          onRowDblClick={(e) => {
            history.push(`/role/${e.data.id}`);
          }}
          remoteOperations={true}
          ref={refGrid}
        >
          <FilterRow visible={true} />
          <Column dataField="name" caption="Наименование" sortOrder="asc" />
          <Column
            dataField=""
            caption="Действия"
            width={100}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanEditRoles']}>
                <div>
                  <DropDownButton
                    icon="overflow"
                    items={variants}
                    onItemClick={(e) => onItemClickHandler(e, data.key)}
                    dropDownOptions={{
                      width: 300,
                    }}
                    className="dropdown-dots"
                    displayExpr="name"
                    keyExpr="id"
                  />
                </div>
              </ClaimsProvider>
            )}
          />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default Role;
